import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { AppSettings } from '../shared/AppSettings';

@Injectable()
export class RecipientManagementService {
  readonly rootUrl = AppSettings.webApiURL; 

  constructor(public httpClient: HttpClient) { }


  public getRecipients() {
    return this.httpClient.get(`${this.rootUrl}/api/RecipientManagementApi/GetRecipients`);
  }

  public getRecipient(id) {
    return this.httpClient.get(`${this.rootUrl}/api/RecipientManagementApi/getRecipient?id=${id}`);
  }

  public SaveRecipient(recipient) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.httpClient.post(`${this.rootUrl}/api/RecipientManagementApi/SaveRecipient`, recipient, { headers });
  }

  

}



// WEBPACK FOOTER //
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/app/service/recipient-management.service.ts